module.exports = __webpack_public_path__ + "src/img/paolo_mantini.337e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/paolo_mantini.jpg
// module id = 247
// module chunks = 0